export default "__VITE_ASSET__84cf4784__"